export default __webpack_public_path__ + "static/media/img-palhaco-mobal.f5485d68.png";